<template lang="pug">
    .game-container
          .game__prepared_items
               .game__prepared_item {{ preparedItem }}
               .game__answer_item {{ answerToShow }}
          img.game__distraction_item(
              v-if="pictures"
              ref='distractionImage'
              :src="getDistractionImg()"
              )
</template>

<script>
    import { mapState } from 'vuex';
    const MAX_IMAGE_HEIGHT = 200;
    const MAX_IMAGE_WIDTH = 150;

    export default {
        props: {
            preparedItems: Array,
            time: Number,
            showTime: Number,
            wordsMovement: Boolean,
            pictures: Boolean,
            courseType: String,
        },
        data() {
            return {
                preparedItem: null,
                answers: {
                    ru: ['Л', 'П', 'О'],
                    en: ['L', 'R', 'B'],
                    fr: ['G', 'D', 'LD'],
                    uk: ['Л', 'П', 'О'],
                    lv: ['K', 'L', 'A'],
                    bg: ['Л', 'В', 'Д'],
                    es: ['I', 'D', 'A'],
                },
                answerToShow: null,
            };
        },
        watch: {
            time(val) {
                if (val % this.showTime === 0 || val === 1) {
                    this.getCurrentHand();
                    this.getItemToShow();
                }
            },
        },
        mounted() {
            this.$nextTick(() => {
                let image = this.$refs.distractionImage;
                if (image) {
                    image.onload = () => {
                        this.getDistractionImageSize();
                    };
                }
            });
        },
        methods: {
            getRandomIndex(array) {
                const numOfItems = array.length;
                return Math.floor(Math.random() * numOfItems);
            },
            getDistractionImageSize() {
                let coefficient = window.innerWidth >= 1200 ? 0.8 : 0.4;
                this.$refs.distractionImage.style.width = this.$refs.distractionImage.naturalWidth * coefficient + 'px';
                this.$refs.distractionImage.style.height = this.$refs.distractionImage.naturalHeight * coefficient + 'px';
            },
            generateItemPosition(className) {
                let containerWidth = document.querySelector('.game-container').clientWidth;
                let containerHeight = document.querySelector('.game-container').clientHeight;
                let item = document.querySelector(className).style;
                if (window.innerWidth > 1200) {
                    item.top = _.random(0, containerHeight - MAX_IMAGE_HEIGHT) + 'px';
                    item.left = _.random(0, containerWidth - MAX_IMAGE_WIDTH) + 'px';
                }
                if (window.innerWidth >= 992 && window.innerWidth <= 1200) {
                    item.top = _.random(0, containerHeight - MAX_IMAGE_HEIGHT - 50) + 'px';
                    item.left = _.random(0, containerWidth - MAX_IMAGE_WIDTH - 50) + 'px';
                }
                if (window.innerWidth < 992) {
                    item.top = _.random(0, containerHeight - MAX_IMAGE_HEIGHT + 50) + 'px';
                    item.left = _.random(0, containerWidth - MAX_IMAGE_WIDTH) + 'px';
                }
            },
            getDistractingImagePosition() {
                if (this.$refs.distractionImage) {
                    this.$refs.distractionImage.style.left = 0;
                    this.$refs.distractionImage.style.top = 0;
                    let containerWidth = document.querySelector('.game-container').clientWidth;
                    let containerHeight = document.querySelector('.game-container').clientHeight;
                    this.$refs.distractionImage.style.left = _.random(0, containerWidth - this.$refs.distractionImage.naturalWidth) + 'px';
                    this.$refs.distractionImage.style.top = _.random(0, containerHeight - this.$refs.distractionImage.naturalWidth) + 'px';
                }
            },
            getDistractionImg() {
                const randomNumber = _.random(0, 28);
                return '/imgs/distracting-pictures/' + randomNumber + '.png';
            },
            getItemToShow() {
                let prevRes = this.preparedItem;
                let futureRes = this.preparedItems[this.getRandomIndex(this.preparedItems)];
                if (futureRes === prevRes) {
                    return this.getItemToShow();
                } else {
                    this.preparedItem = futureRes;
                }
                this.pictures && this.getDistractingImagePosition();
                this.wordsMovement && this.generateItemPosition('.game__prepared_items');
            },
            getCurrentHand() {
                let prevRes = this.answerToShow;
                let futureRes = this.translatedAnswers[this.getRandomIndex(this.translatedAnswers)];
                if (futureRes === prevRes) {
                    return this.getCurrentHand();
                } else {
                    this.answerToShow = futureRes;
                }
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            translatedAnswers() {
                if (this.user.locale in this.answers && this.courseType !== 'readingEn') {
                    return this.answers[this.user.locale];
                } else {
                    return this.answers['en'];
                }
            },
        },
    };
</script>

<style scoped lang="scss">
    .game-container {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 90%;
        height: 100%;
        font-size: 50px;
        font-weight: 600;
        @include media($lg) {
            font-size: 100px;
        }
        @include media($xlg) {
            font-size: 120px;
        }
    }
    .game__prepared_items {
        z-index: 100;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: absolute;
    }
    .game__distraction_item {
        position: absolute;
        opacity: 0.6;
    }

    .game__answer_item {
        color: $hsl-color-red-62;
    }
</style>
